import { API_ENDPOINT } from "@/utils/misc";
import axios from "axios";

export const getTemplateJobsList = () => {
  return axios.get(`${API_ENDPOINT()}/template-jobs`);
};
